var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.operate] || "-",
          backUrl: _vm.backUrl,
          "close-now-tag": "",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.currentTab >= "1"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "1",
                          expression: "currentTab === '1'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属应用",
                                prop: "applicationIds",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: { multiple: "" },
                                  model: {
                                    value: _vm.formData.applicationIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "applicationIds",
                                        $$v
                                      )
                                    },
                                    expression: "formData.applicationIds",
                                  },
                                },
                                [
                                  _vm._l(_vm.appList, function (item, index) {
                                    return [
                                      _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                          disabled: item.disabled,
                                        },
                                      }),
                                    ]
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "开奖类型：",
                                prop: "activityType",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled || _vm.isEdit,
                                    size: "small",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeType },
                                  model: {
                                    value: _vm.formData.activityType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "activityType",
                                        $$v
                                      )
                                    },
                                    expression: "formData.activityType",
                                  },
                                },
                                _vm._l(_vm.typeOptions, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动名称：",
                                prop: "activityName",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  maxlength: "100",
                                  "show-word-limit": "",
                                  placeholder: "请输入活动名称",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.activityName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "activityName",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.activityName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动样式：",
                                prop: "activityStyle",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled || _vm.isEdit,
                                    size: "small",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.changeStyle },
                                  model: {
                                    value: _vm.formData.activityStyle,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "activityStyle",
                                        $$v
                                      )
                                    },
                                    expression: "formData.activityStyle",
                                  },
                                },
                                _vm._l(
                                  _vm.styleOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                        disabled: item.disabled,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "活动时间：", prop: "drawTime" },
                            },
                            [
                              _vm.formData.activityType === 1
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value:
                                              _vm.formData.activityLimitTime,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData,
                                                "activityLimitTime",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.activityLimitTime",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("有效期")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 2 } },
                                            [_vm._v("无限制")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.formData.activityLimitTime === 1
                                ? _c("el-date-picker", {
                                    staticClass: "from-ipt-width",
                                    attrs: {
                                      size: "small",
                                      type: "datetimerange",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "default-time": ["00:00:00", "23:59:59"],
                                      "start-placeholder": "开始时间",
                                      "end-placeholder": "结束时间",
                                      "picker-options": _vm.pickerOptions,
                                      disabled: _vm.isDisabled,
                                      align: "right",
                                    },
                                    model: {
                                      value: _vm.formData.drawTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "drawTime", $$v)
                                      },
                                      expression: "formData.drawTime",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm.formData.activityType === 2
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "开奖时间：",
                                      prop: "winTime",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      staticClass: "from-ipt-width",
                                      attrs: {
                                        size: "small",
                                        type: "datetime",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        format: "yyyy-MM-dd HH:mm:ss",
                                        "default-time": "12:00:00",
                                        "start-placeholder": "开奖时间",
                                        "picker-options": _vm.pickerOptions,
                                        disabled: _vm.isDisabled,
                                        align: "right",
                                      },
                                      model: {
                                        value: _vm.formData.winTime,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "winTime", $$v)
                                        },
                                        expression: "formData.winTime",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "兑奖有效期：",
                                prop: "validityDate",
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 0.1,
                                  disabled: _vm.isDisabled,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入时间",
                                },
                                model: {
                                  value: _vm.formData.validityDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "validityDate", $$v)
                                  },
                                  expression: "formData.validityDate",
                                },
                              }),
                              _vm._v(" 小时 "),
                            ],
                            1
                          ),
                          _vm.formData.activityType === 2
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "首页展示：",
                                      prop: "indexFlag",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                        width: 35,
                                        disabled: _vm.isDisabled,
                                      },
                                      model: {
                                        value: _vm.formData.indexFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "indexFlag",
                                            $$v
                                          )
                                        },
                                        expression: "formData.indexFlag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "置顶banner展示：",
                                      prop: "bannerFlag",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 2,
                                        "inactive-value": 1,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                        width: 35,
                                        disabled: _vm.isDisabled,
                                      },
                                      model: {
                                        value: _vm.formData.bannerFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "bannerFlag",
                                            $$v
                                          )
                                        },
                                        expression: "formData.bannerFlag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序：", prop: "sort" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  max: 9999,
                                  step: 1,
                                  disabled: _vm.isDisabled,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入排序值",
                                },
                                model: {
                                  value: _vm.formData.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sort", $$v)
                                  },
                                  expression: "formData.sort",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动说明：", prop: "remark" } },
                            [
                              _c(
                                "div",
                                { staticClass: "editor-content" },
                                [
                                  !_vm.isDisabled
                                    ? _c("Tinymce", {
                                        model: {
                                          value: _vm.formData.remark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "formData.remark",
                                        },
                                      })
                                    : _c("div", {
                                        staticClass: "editor-content-inner",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.formData.remark
                                          ),
                                        },
                                      }),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "客服：", prop: "qrcodeId" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    placeholder: "请选择客服",
                                    filterable: "",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.formData.qrcodeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "qrcodeId", $$v)
                                    },
                                    expression: "formData.qrcodeId",
                                  },
                                },
                                _vm._l(_vm.qrcodeList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.pageName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "客服按钮文案：",
                                prop: "popupDes",
                              },
                            },
                            [
                              _c("el-input", {
                                staticClass: "from-ipt-width",
                                attrs: {
                                  maxlength: "4",
                                  "show-word-limit": "",
                                  placeholder: "请输入客服按钮文案",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.popupDes,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "popupDes",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.popupDes",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.formData.activityType === 2
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "奖品说明：",
                                      prop: "prizeDes",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "editor-content" },
                                      [
                                        !_vm.isDisabled
                                          ? _c("Tinymce", {
                                              model: {
                                                value: _vm.formData.prizeDes,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "prizeDes",
                                                    $$v
                                                  )
                                                },
                                                expression: "formData.prizeDes",
                                              },
                                            })
                                          : _c("div", {
                                              staticClass:
                                                "editor-content-inner",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.formData.prizeDes
                                                ),
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "活动封面图：",
                                prop: "activityCoverPic",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upLoadPicBox acea-row",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap("activityCoverPic")
                                    },
                                  },
                                },
                                [
                                  _vm.formData.activityCoverPic
                                    ? _c("div", { staticClass: "pictrue" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.formData.activityCoverPic,
                                          },
                                        }),
                                      ])
                                    : _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.isDisabled,
                                      expression: "!isDisabled",
                                    },
                                  ],
                                  staticClass: "from-tips",
                                },
                                [
                                  _vm._v(
                                    "建议尺寸：700*352px，上传小于1mb的图片"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentTab >= "2"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "2",
                          expression: "currentTab === '2'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "参与条件：", prop: "joinType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled,
                                    size: "small",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.formData.joinType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "joinType", $$v)
                                    },
                                    expression: "formData.joinType",
                                  },
                                },
                                _vm._l(
                                  _vm.joinTypeOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                        disabled: item.disabled,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.formData.joinType === 2 ||
                          _vm.formData.joinType === 6
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "消耗积分：",
                                    prop: "joinCostPoints",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      step: 1,
                                      disabled: _vm.isDisabled,
                                      "controls-position": "right",
                                      "step-strictly": "",
                                      placeholder: "请输入消耗积分",
                                    },
                                    model: {
                                      value: _vm.formData.joinCostPoints,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "joinCostPoints",
                                          $$v
                                        )
                                      },
                                      expression: "formData.joinCostPoints",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.joinType === 3
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "展示广告：", prop: "advId" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "from-ipt-width",
                                      attrs: {
                                        disabled: _vm.isDisabled,
                                        size: "small",
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.formData.advId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "advId", $$v)
                                        },
                                        expression: "formData.advId",
                                      },
                                    },
                                    _vm._l(_vm.advList, function (item, idx) {
                                      return _c("el-option", {
                                        key: idx,
                                        attrs: {
                                          label:
                                            item.adName + "(" + item.id + ")",
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm.formData.joinType === 5
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "跳转类型：",
                                      prop: "jumpType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: _vm.isDisabled },
                                        model: {
                                          value: _vm.formData.jumpType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "jumpType",
                                              $$v
                                            )
                                          },
                                          expression: "formData.jumpType",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("直接跳转")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 2 } },
                                          [_vm._v("半屏小程序")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "小程序appid：",
                                      prop: "appId",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "from-ipt-width",
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: _vm.formData.appId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "appId", $$v)
                                        },
                                        expression: "formData.appId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "页面路径：",
                                      prop: "jumpUrl",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "from-ipt-width",
                                      attrs: { disabled: _vm.isDisabled },
                                      model: {
                                        value: _vm.formData.jumpUrl,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "jumpUrl", $$v)
                                        },
                                        expression: "formData.jumpUrl",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm.formData.joinType === 6
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "积分抽奖机会：",
                                      prop: "coinDrawTimes",
                                    },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 1,
                                        max: 999999999,
                                        step: 1,
                                        disabled: _vm.isDisabled,
                                        "controls-position": "right",
                                        "step-strictly": "",
                                      },
                                      model: {
                                        value: _vm.formData.coinDrawTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "coinDrawTimes",
                                            $$v
                                          )
                                        },
                                        expression: "formData.coinDrawTimes",
                                      },
                                    }),
                                    _vm._v("次 "),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "激励视频机会：",
                                      prop: "videoDrawTimes",
                                    },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 1,
                                        max: 999999999,
                                        step: 1,
                                        disabled: _vm.isDisabled,
                                        "controls-position": "right",
                                        "step-strictly": "",
                                      },
                                      model: {
                                        value: _vm.formData.videoDrawTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "videoDrawTimes",
                                            $$v
                                          )
                                        },
                                        expression: "formData.videoDrawTimes",
                                      },
                                    }),
                                    _vm._v("次 "),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm.formData.activityType !== 2 &&
                          _vm.formData.joinType !== 6
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "抽奖机会：",
                                    prop: "dailyLimit",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    { attrs: { value: 1, size: "small" } },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "每人每日抽奖次数",
                                          value: 1,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("el-input-number", {
                                    attrs: {
                                      min: 1,
                                      step: 1,
                                      disabled: _vm.isDisabled,
                                      "controls-position": "right",
                                      "step-strictly": "",
                                      placeholder: "请输入抽奖次数",
                                    },
                                    model: {
                                      value: _vm.formData.dailyLimit,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "dailyLimit",
                                          $$v
                                        )
                                      },
                                      expression: "formData.dailyLimit",
                                    },
                                  }),
                                  _c("div", { staticClass: "from-tips" }, [
                                    _vm._v("控制活动参与次数上限"),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.activityType === 2
                            ? [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "基础人数：",
                                      prop: "initUserNum",
                                    },
                                  },
                                  [
                                    _c("el-input-number", {
                                      attrs: {
                                        min: 1,
                                        step: 1,
                                        disabled: _vm.isDisabled,
                                        "controls-position": "right",
                                        "step-strictly": "",
                                        placeholder: "请输入基础人数",
                                      },
                                      model: {
                                        value: _vm.formData.initUserNum,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "initUserNum",
                                            $$v
                                          )
                                        },
                                        expression: "formData.initUserNum",
                                      },
                                    }),
                                    _c("div", { staticClass: "from-tips" }, [
                                      _vm._v(
                                        "默认初始机器人数量，供前端展示用"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "往期中奖锦鲤",
                                      prop: "replyIds",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "from-ipt-width",
                                        attrs: {
                                          disabled: _vm.isDisabled,
                                          placeholder: "请选择往期中奖锦鲤",
                                          multiple: "",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.formData.replyIds,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "replyIds",
                                              $$v
                                            )
                                          },
                                          expression: "formData.replyIds",
                                        },
                                      },
                                      [
                                        _vm.replyList.length > 1
                                          ? _c(
                                              "el-checkbox",
                                              {
                                                staticStyle: {
                                                  padding: "5px 20px 10px",
                                                },
                                                model: {
                                                  value: _vm.isReplyAll,
                                                  callback: function ($$v) {
                                                    _vm.isReplyAll = $$v
                                                  },
                                                  expression: "isReplyAll",
                                                },
                                              },
                                              [_vm._v("全选")]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.replyList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                value: item.id,
                                                label: item.userName,
                                              },
                                            })
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "是否助力：",
                                      prop: "assistFlag",
                                    },
                                  },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 2,
                                        "inactive-value": 1,
                                        "active-text": "开启",
                                        "inactive-text": "关闭",
                                        width: 35,
                                        disabled: _vm.isDisabled,
                                      },
                                      model: {
                                        value: _vm.formData.assistFlag,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "assistFlag",
                                            $$v
                                          )
                                        },
                                        expression: "formData.assistFlag",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.formData.assistFlag === 2
                                  ? [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "助力基础人数：",
                                            prop: "assistInitNum",
                                          },
                                        },
                                        [
                                          _c("el-input-number", {
                                            attrs: {
                                              min: 1,
                                              step: 1,
                                              disabled: _vm.isDisabled,
                                              "controls-position": "right",
                                              "step-strictly": "",
                                              placeholder: "请输入助力基础人数",
                                            },
                                            model: {
                                              value: _vm.formData.assistInitNum,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "assistInitNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.assistInitNum",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "from-tips" },
                                            [
                                              _vm._v(
                                                "活动默认助力人数，最佳展示为默认参与人数的90%"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      !_vm.isDisabled
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "small",
                                              },
                                              on: { click: _vm.addTaskItem },
                                            },
                                            [_vm._v(" 添加任务 ")]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "el-tabs",
                                        {
                                          staticClass: "mt14",
                                          attrs: { type: "border-card" },
                                          on: {
                                            "tab-remove": _vm.removeTaskItem,
                                          },
                                          model: {
                                            value: _vm.taskTab,
                                            callback: function ($$v) {
                                              _vm.taskTab = $$v
                                            },
                                            expression: "taskTab",
                                          },
                                        },
                                        _vm._l(
                                          _vm.formData.assistTasks,
                                          function (item, index) {
                                            return _c(
                                              "el-tab-pane",
                                              {
                                                key: index,
                                                attrs: {
                                                  label: "任务" + (index + 1),
                                                  name: index.toString(),
                                                  closable:
                                                    !_vm.isDisabled &&
                                                    index !== 0,
                                                },
                                              },
                                              [
                                                _c("task-item", {
                                                  attrs: {
                                                    value: item,
                                                    index: index,
                                                    "is-auto": index === 0,
                                                    disabled: _vm.isDisabled,
                                                    "ad-list": _vm.advList,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentTab >= "3"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "3",
                          expression: "currentTab === '3'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid, false),
                        [
                          !_vm.isDisabled
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    disabled:
                                      _vm.formData.prizes.length >=
                                      _vm.maxPrizeLength,
                                  },
                                  on: { click: _vm.addPrizeItem },
                                },
                                [_vm._v(" 添加奖项 ")]
                              )
                            : _vm._e(),
                          _c(
                            "el-tabs",
                            {
                              staticClass: "mt14",
                              attrs: { type: "border-card" },
                              on: { "tab-remove": _vm.removePrizeItem },
                              model: {
                                value: _vm.prizeTab,
                                callback: function ($$v) {
                                  _vm.prizeTab = $$v
                                },
                                expression: "prizeTab",
                              },
                            },
                            _vm._l(_vm.formData.prizes, function (item, index) {
                              return _c(
                                "el-tab-pane",
                                {
                                  key: index,
                                  attrs: {
                                    label:
                                      item.prizeType === 99
                                        ? "谢谢参与"
                                        : "奖项" + (index + 1),
                                    name: index.toString(),
                                    closable:
                                      !_vm.isDisabled &&
                                      _vm.formData.prizes.length > 1 &&
                                      (index !==
                                        _vm.formData.prizes.length - 1 ||
                                        _vm.formData.activityType === 2) &&
                                      _vm.prizeRemovable,
                                  },
                                },
                                [
                                  _c("prize-item", {
                                    attrs: {
                                      type: _vm.formData.activityStyle,
                                      value: item,
                                      index: index,
                                      "is-auto":
                                        _vm.formData.activityType !== 2 &&
                                        index ===
                                          _vm.formData.prizes.length - 1,
                                      disabled: _vm.isDisabled,
                                      "is-edit": _vm.isEdit && !!item.prizeId,
                                      winProbability:
                                        _vm.prizeWinProbabilityTotal,
                                    },
                                    on: { winFlagChange: _vm.winFlagChange },
                                  }),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitUp },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < _vm.headTab.length,
                          expression: "Number(currentTab) < headTab.length",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest("formData")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:lottery-assistant:activity:save",
                            "platform:lottery-assistant:activity:update",
                          ],
                          expression:
                            "['platform:lottery-assistant:activity:save', 'platform:lottery-assistant:activity:update']",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (_vm.currentTab === "3" || _vm.$route.params.id) &&
                            !_vm.isDisabled,
                          expression:
                            "(currentTab === '3' || $route.params.id) && !isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }